(function () {
  if (window.__blsCouponManagerInitialized) return;
  window.__blsCouponManagerInitialized = true;

  const state = { pending: false };

  function text(container, key, fallback) {
    const value = container?.dataset?.[key];
    return value && String(value).trim() ? value : fallback;
  }

  function moneyFormat(cents) {
    const format =
      window.cartStrings?.money_format ||
      window.themeGlobalVariables?.settings?.money_format ||
      "${{amount}}";
    if (typeof Shopify?.formatMoney === "function") {
      return Shopify.formatMoney(cents, format);
    }
    return String(cents);
  }

  function setFeedback(container, message, type) {
    const node = container?.querySelector("[data-coupon-feedback]");
    if (!node) return;
    if (!message) {
      node.classList.add("hidden");
      node.textContent = "";
      node.style.color = "";
      return;
    }
    node.classList.remove("hidden");
    node.textContent = message;
    node.style.color = type === "success" ? "#188038" : "#d0473e";
  }

  function setLoading(container, loading) {
    container?.querySelectorAll("[data-coupon-apply], [data-coupon-remove]").forEach((btn) => {
      btn.disabled = loading;
      btn.classList.toggle("opacity-70", loading);
      btn.classList.toggle("pointer-none", loading);
    });
  }

  function updateHeaderAndCounts(cart) {
    if (!cart) return;
    document.querySelectorAll(".cart-count").forEach((el) => {
      if (el.classList.contains("cart-count-drawer")) {
        el.innerHTML = `(${cart.item_count || 0})`;
      } else {
        const count = cart.item_count || 0;
        el.innerHTML = count > 100 ? "~" : count;
      }
    });
    if (document.querySelector("header-total-price")) {
      document.querySelector("header-total-price").updateTotal(cart);
    }
  }

  async function fetchCart() {
    const response = await fetch("/cart.js", { credentials: "same-origin" });
    if (!response.ok) throw new Error("Network/API failure");
    return response.json();
  }

  async function updateDiscount(discountCode) {
    const response = await fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ discount: discountCode }),
      credentials: "same-origin",
    });
    if (!response.ok) {
      let message = "Invalid or expired coupon code.";
      try {
        const data = await response.json();
        if (data?.description) message = data.description;
      } catch (e) {}
      throw new Error(message);
    }
    return response.json();
  }

  async function refreshSections() {
    const sectionIds = [];
    const cartRoot = document.getElementById("main-cart-items");
    if (cartRoot?.dataset?.id) sectionIds.push(cartRoot.dataset.id);
    if (document.getElementById("minicart-form")) sectionIds.push("minicart-form");
    if (!sectionIds.length) return;

    const basePath = window.location.pathname || "/cart";
    const url = `${basePath}?sections=${encodeURIComponent(sectionIds.join(","))}`;
    const response = await fetch(url, { credentials: "same-origin" });
    if (!response.ok) return;
    const sections = await response.json();

    if (cartRoot?.dataset?.id && sections[cartRoot.dataset.id]) {
      const html = new DOMParser().parseFromString(sections[cartRoot.dataset.id], "text/html");
      const newJsContents = html.querySelector("#main-cart-items .js-contents");
      const currentJsContents = document.querySelector("#main-cart-items .js-contents");
      if (newJsContents && currentJsContents) currentJsContents.innerHTML = newJsContents.innerHTML;

      const newTotals = html.querySelector("#main-cart-items .cart-info .totals");
      const currentTotals = document.querySelector("#main-cart-items .cart-info .totals");
      if (newTotals && currentTotals) currentTotals.innerHTML = newTotals.innerHTML;
    }

    if (sections["minicart-form"]) {
      const html = new DOMParser().parseFromString(sections["minicart-form"], "text/html");
      const newMini = html.querySelector("#minicart-form");
      const currentMini = document.getElementById("minicart-form");
      if (newMini && currentMini) currentMini.innerHTML = newMini.innerHTML;
    }
  }

  function syncTotals(cart) {
    const total = moneyFormat(cart.total_price || 0);
    document.querySelectorAll("[data-cart-total-price], [data-cart-subtotal-price]").forEach((node) => {
      node.innerHTML = total;
    });
  }

  function renderAppliedCoupons(cart) {
    const apps = Array.isArray(cart?.cart_level_discount_applications)
      ? cart.cart_level_discount_applications
      : [];
    document.querySelectorAll("[data-coupon-applied]").forEach((container) => {
      if (!apps.length) {
        container.innerHTML = "";
        return;
      }
      const isMini = !!container.closest("#minicart-form");
      const removeLabel = text(container, "couponRemoveLabel", "Remove");
      const appliedPrefix = text(container, "couponAppliedPrefix", "Coupon Applied");
      const html = apps
        .map((app) => {
          const amount = moneyFormat(app.total_allocated_amount || 0);
          const title = (app.title || "").toUpperCase();
          const label = isMini
            ? `${title} (-${amount})`
            : `${appliedPrefix}: ${app.title} (-${amount})`;
          return `<li class="discounts__discount discounts__discount--position flex justify-between align-center gap-10"><span>${label}</span><button type="button" class="btn-reset underline" data-coupon-remove>${removeLabel}</button></li>`;
        })
        .join("");
      container.innerHTML = `<ul class="discounts list-none pl-0 ml-0 mb-5" role="list">${html}</ul>`;
    });
  }

  async function refreshAll() {
    const cart = await fetchCart();
    updateHeaderAndCounts(cart);
    syncTotals(cart);
    renderAppliedCoupons(cart);
    await refreshSections();
    return cart;
  }

  function isCouponApplied(cart) {
    return Array.isArray(cart?.cart_level_discount_applications) && cart.cart_level_discount_applications.length > 0;
  }

  async function applyCoupon(container) {
    if (state.pending) return;
    const input = container.querySelector("[data-coupon-input]");
    if (!input) return;
    const code = (input.value || "").trim();
    if (!code) {
      setFeedback(container, text(container, "couponMsgEmpty", "Please enter a coupon code."), "error");
      input.focus();
      return;
    }
    state.pending = true;
    setLoading(container, true);
    setFeedback(container, text(container, "couponMsgApplying", "Applying coupon..."), "success");
    try {
      const before = await fetchCart();
      if (before.cart_level_discount_applications?.some((d) => d.title?.toLowerCase() === code.toLowerCase())) {
        setFeedback(container, text(container, "couponMsgAlready", "Coupon is already applied."), "error");
        return;
      }
      await updateDiscount(code);
      const after = await refreshAll();
      if (!isCouponApplied(after)) {
        setFeedback(container, text(container, "couponMsgInvalid", "Invalid or expired coupon code."), "error");
        return;
      }
      setFeedback(container, text(container, "couponMsgSuccess", "Coupon applied successfully."), "success");
    } catch (error) {
      setFeedback(container, error.message || "Network/API failure", "error");
    } finally {
      state.pending = false;
      setLoading(container, false);
    }
  }

  async function removeCoupon(container) {
    if (state.pending) return;
    state.pending = true;
    setLoading(container, true);
    setFeedback(container, text(container, "couponMsgRemoving", "Removing coupon..."), "success");
    try {
      await updateDiscount("");
      await refreshAll();
      const input = container.querySelector("[data-coupon-input]");
      if (input) input.value = "";
      setFeedback(container, "", "");
    } catch (error) {
      setFeedback(container, error.message || "Network/API failure", "error");
    } finally {
      state.pending = false;
      setLoading(container, false);
    }
  }

  document.addEventListener("click", (event) => {
    const applyBtn = event.target.closest("[data-coupon-apply]");
    if (applyBtn) {
      event.preventDefault();
      const container = applyBtn.closest("[data-coupon-container]");
      if (container) applyCoupon(container);
      return;
    }

    const removeBtn = event.target.closest("[data-coupon-remove]");
    if (removeBtn) {
      event.preventDefault();
      const scope = removeBtn.closest("#main-cart-items, #minicart-form") || document;
      const container = scope.querySelector("[data-coupon-container]") || document.querySelector("[data-coupon-container]");
      if (container) removeCoupon(container);
      return;
    }

    const toggleBtn = event.target.closest("[data-coupon-toggle]");
    if (toggleBtn) {
      event.preventDefault();
      const container = toggleBtn.closest("[data-coupon-container]");
      const row = container?.querySelector("[data-coupon-row]");
      if (!row) return;
      const isHidden = row.classList.contains("hidden");
      row.classList.toggle("hidden");
      toggleBtn.setAttribute("aria-expanded", isHidden ? "true" : "false");
      if (isHidden) {
        const input = container.querySelector("[data-coupon-input]");
        if (input) input.focus();
      }
    }
  });

  document.addEventListener("keydown", (event) => {
    if (event.key !== "Enter") return;
    const input = event.target.closest("[data-coupon-input]");
    if (!input) return;
    event.preventDefault();
    const container = input.closest("[data-coupon-container]");
    if (container) applyCoupon(container);
  });
})();
